import * as ChartAPI from '../repositories/ChartAPI'
import APIHeaders from '@/entities/APIHeaders';
import dayjs from 'dayjs'
import Daily from '@/entities/chart/Daily';
import DailyForAWeek from '@/entities/DailyForAWeek';
import WeeklyForAMonth from '@/entities/WeeklyForAMonth';

export const dailyForAWeek = (headers: APIHeaders, childId:number, toDate?: string) : Promise<Daily[]> => {
  return new Promise<Daily[]>(async(resolve, reject) => {

    let histories: DailyForAWeek[]

    try {
      histories = await ChartAPI.dailyForAWeek(headers, childId, toDate)
    } catch (e) {
      return reject(e)
    }

    let today = toDate !== undefined ? dayjs(toDate) : dayjs(Date())

    if (isNaN(today.unix())) {
      today = dayjs(Date())
    }

    const days: Date[] = []
    // 1週間分作成
    for (const i of [0, 1, 2, 3, 4, 5, 6]) {
      const date = today.add(-i, 'day').toDate()
      days.push(date)
    }

    const output: Daily[] = []
    days.forEach((day, index) => {
      const oneDay = dayjs(day).format('YYYY-MM-DD')
      const dailyForAWeek = histories.filter(v => v.date === oneDay)[0]
      const value = dailyForAWeek !== undefined ? dailyForAWeek.value : null
      output.push(new Daily(day, value))
    })

    // 過去日から並ぶようreverseして返す
    return resolve(output.reverse())
  })
}

//
export const weeklyForAMonth = (headers: APIHeaders, childId:number, toDate?: string) : Promise<Daily[]> => {
  return new Promise<Daily[]>(async(resolve, reject) => {

    let histories: WeeklyForAMonth[]

    try {
      histories = await ChartAPI.weeklyForAMonth(headers, childId, toDate)
    } catch (e) {
      return reject(e)
    }

    let today = toDate !== undefined ? dayjs(toDate) : dayjs(Date())

    if (isNaN(today.unix())) {
      today = dayjs(Date())
    }

    //一月前をミリ秒で取得 1318781876406
    let dayAMonthAgo = dayjs(today).add(-1,'month').valueOf();
    //選択した日の月曜日を取得
    let diffDayForMonday = dayjs(today).day()-1;//-1~5
    if (diffDayForMonday < 0){
      //日曜日の場合
      diffDayForMonday += 7
    }
    let first_monday = today.subtract(diffDayForMonday,'day');
    // 1ヶ月分の全ての月曜日の配列を作成
    let monday = first_monday
    const mondays: Date[] = []
    for (const i of [0, 1, 2, 3, 4]){
      let pushedDay = dayjs(monday).add(-i,'week')
      mondays.push(pushedDay.toDate())
    }

    const output: Daily[] = []
    mondays.forEach((day, index) => {
      const oneDay = dayjs(day).format('YYYY-MM-DD')
      const weeklyForAMonth = histories.filter(v => v.start_date === oneDay)[0]
      const value = weeklyForAMonth !== undefined ? weeklyForAMonth.value : null
      output.push(new Daily(day, value))
    })

    // 過去日から並ぶようreverseして返す
    return resolve(output.reverse())
  })
}